import classNames from "classnames";

import { useTranslation } from "i18n";

import { DatePicker } from "./DatePicker";
import { DateRange } from "./utils";

export const DateRangeFilter = ({
  value,
  onChange,
  wrapperClassName,
}: {
  value: DateRange;
  onChange: (value: DateRange) => void;
  wrapperClassName?: string;
}) => {
  const t = useTranslation();

  return (
    <div className={classNames("flex space-x-16", wrapperClassName)}>
      <DatePicker
        isClearable
        wrapperClassName="flex-1"
        label={t("form.date_picker.date_range_filter.from")}
        value={value.from}
        maxDate={value.to}
        onChange={(from) => onChange({ ...value, from: from?.startOfDay() })}
      />
      <DatePicker
        isClearable
        wrapperClassName="flex-1"
        label={t("form.date_picker.date_range_filter.to")}
        value={value.to}
        minDate={value.from}
        onChange={(to) => onChange({ ...value, to: to?.endOfDay() })}
      />
    </div>
  );
};
